import { ButtonIcon, Table } from "mta-rkvr-styles";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { get, remove } from "../api/fetch";
import { BalanceMessagesResponseBody } from "../api/HomePageResponseTypes";
import { BalanceMessage, ColumnHeader } from "../types/homepage/AssetAccountingMessages";
import { Paginator } from "../types/util/TableFunctionalityTypes";
import { mapClassifiersValuesToLabels } from "../util/classifierManager";
import { toLocaleDate } from "../util/conversionUtils";
import { PROCEEDINGS } from "../util/paths";

const AssetAccountingMessages = () => {
  const { t } = useTranslation();
  const tBase = "homePageAuth.assetAccountingMessages.";

  const [refreshObservable, setRefreshObservable] = useState(false);
  const refresh = () => {
    setRefreshObservable(!refreshObservable);
  };
  const [isLoading, setLoading] = useState(false);
  const [messages, setMessages] = useState<BalanceMessage[]>();

  useEffect(() => {
    getMessages();
  }, [refreshObservable]);

  const getMessages = (pageSize?: number, elementOffset?: number) => {
    if (isLoading) {
      return;
    }
    setLoading(true);
    get<BalanceMessagesResponseBody>({
      endPoint: "balanceMessages",
      queryParams: [
        { name: "limit", value: pageSize ? pageSize : 10 },
        { name: "offset", value: elementOffset ? elementOffset : 0 },
      ],
    }).then(async ({ body }) => {
      const { resultsList: messages } = body;
      const labelsObject = await mapClassifiersValuesToLabels([
        {
          type: "menetlusType",
          values: messages.map((message) => message.liik),
        },
        {
          type: "menetlusTypeSubtype",
          values: messages.map((message) => message.alamliik),
        },
      ]);

      setMessages(
        body.resultsList.map((message) => {
          return {
            ...message,
            liik: {
              label: labelsObject.menetlusType!.shift()!,
              value: message.liik,
            },
            alamliik: {
              label: labelsObject.menetlusTypeSubtype!.shift()!,
              value: message.alamliik,
            },
            lopetatud: toLocaleDate(message.lopetatud),
          };
        }),
      );
      setPaginator({
        pageSize: body.limit,
        elementOffset: body.offset,
        numberOfElements: body.resultCount,
        totalElements: body.totalCount,
      });
      setLoading(false);
    });
  };

  const [paginator, setPaginator] = useState<Paginator>();

  const onPagination = (paginator: { pageSize: number; elementOffset: number }) => {
    getMessages(paginator.pageSize, paginator.elementOffset);
  };

  const markDone = (id: number) => {
    remove<never>({ endpoint: "accountMessages", pathParams: [id] }).then((res) => {
      res.ok && refresh();
    });
  };

  return (
    <>
      {messages && (
        <Table
          id={t(tBase + "title")}
          title={t(tBase + "title")}
          headers={Object.keys(ColumnHeader).map((header) => {
            return t(tBase + header);
          })}
          paginator={paginator}
          onPagination={onPagination}
          content={messages?.map((message) => {
            const { alamliik, liik, lopetaja, lopetatud, menetluseId, number } = message;
            return {
              number: <Link to={`${PROCEEDINGS}/${menetluseId}`}>{number}</Link>,
              liik: liik.label,
              alamliik: alamliik.label,
              lopetaja,
              lopetatud,
            };
          })}
          translate={t}
          rowIds={messages.map((message) => message.teateId)}
          editable
          customEditRowComponent={(obj: { rowId: number }) => (
            <ButtonIcon
              iconName={"icon-checkerrors"}
              onClick={() => markDone(obj.rowId)}
              tooltip={t(tBase + "markDone")}
            />
          )}
          /* sortableColumns={sortableColumns}
					onSorting={onSorting} */
        />
      )}
    </>
  );
};

export default AssetAccountingMessages;
